var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 1.25C3.82436 1.25 1.25 3.82436 1.25 7V17C1.25 20.1756 3.82436 22.75 7 22.75H17C20.1756 22.75 22.75 20.1756 22.75 17V7C22.75 3.82436 20.1756 1.25 17 1.25H7ZM14.6519 9.34858C14.9448 9.64147 14.9448 10.1163 14.6519 10.4092L13.0609 12.0002L14.6519 13.5913C14.9448 13.8841 14.9448 14.359 14.6519 14.6519C14.359 14.9448 13.8841 14.9448 13.5912 14.6519L12.0002 13.0609L10.4092 14.6519C10.1163 14.9448 9.64147 14.9448 9.34858 14.6519C9.05568 14.359 9.05568 13.8841 9.34858 13.5912L10.9395 12.0002L9.34858 10.4093C9.05568 10.1164 9.05568 9.64151 9.34858 9.34861C9.64147 9.05572 10.1163 9.05572 10.4092 9.34861L12.0002 10.9396L13.5912 9.34858C13.8841 9.05568 14.359 9.05568 14.6519 9.34858Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/Close.295ef44ffc5597ae4cfc097bcf195c5c.svg";
export { ForwardRef as ReactComponent };